export default "__VITE_ASSET__fdf3d846__"